import { config } from "../config";
export async function prepareImage(source) {
    const bitmap = await createImageBitmap(source, {
        imageOrientation: "from-image", // respect EXIF
    });
    const maxDim = config.maxUploadDimension;
    const longest = Math.max(bitmap.width, bitmap.height);
    const scale = longest > maxDim ? maxDim / longest : 1;
    const width = Math.round(bitmap.width * scale);
    const height = Math.round(bitmap.height * scale);
    const canvas = new OffscreenCanvas(width, height);
    const ctx = canvas.getContext("2d");
    if (!ctx) {
        throw new Error("Could not get 2D context for image preparation");
    }
    ctx.drawImage(bitmap, 0, 0, width, height);
    bitmap.close();
    const blob = await canvas.convertToBlob({
        type: "image/jpeg",
        quality: 0.85,
    });
    return { blob, width, height, scale };
}
